/* In-article recommendations sidebar — runtime upgrade.
 *
 * Picks an item source for the sidebar in this priority order:
 *   1. Per-post tags named like  #rec/post/<slug>  or  #rec/yt/<video-id>
 *      (read from hidden <span data-billyou-tag="…"> markers the theme emits).
 *      This is the easy author UX: just add internal tags in the post editor.
 *   2. Per-post JSON override in <script data-billyou-recs>…</script>
 *      (power-user fallback for full URLs + custom labels).
 *   3. Whatever the theme already rendered server-side from site-wide
 *      custom settings — leave it alone.
 *
 * Then for each rendered card: if the URL is YouTube, set the thumbnail
 * (img.youtube.com/vi/<id>/hqdefault.jpg) and tag it data-rec-type="youtube"
 * so CSS draws the play overlay.
 *
 * Card construction is XSS-safe (createElement + textContent only — no
 * innerHTML for any author-supplied string).
 */
(function () {
    'use strict';

    var TAG_PREFIX = '#rec/';

    function youtubeIdFromUrl(url) {
        try {
            var u = new URL(url);
            if (u.hostname === 'youtu.be') {
                return u.pathname.replace(/^\//, '').split('/')[0] || null;
            }
            if (/(^|\.)youtube\.com$/.test(u.hostname)) {
                if (u.pathname === '/watch') return u.searchParams.get('v');
                var m = u.pathname.match(/^\/(?:embed|shorts)\/([^/]+)/);
                if (m) return m[1];
            }
        } catch (e) { /* malformed url — fall through */ }
        return null;
    }

    function siteRoot(root) {
        var attr = root.getAttribute('data-billyou-site');
        if (!attr) return '';
        return attr.replace(/\/$/, '');
    }

    /* "efactura-2026" -> "Efactura 2026" — naive title-casing as a label
       fallback when no friendly label is available. */
    function slugToLabel(slug) {
        return slug
            .split(/[-_]/)
            .filter(Boolean)
            .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
            .join(' ');
    }

    function itemFromTagName(name, root) {
        if (!name || name.indexOf(TAG_PREFIX) !== 0) return null;
        var rest = name.substring(TAG_PREFIX.length); // "post/efactura-2026" or "yt/dQw4w9WgXcQ"
        var slashIdx = rest.indexOf('/');
        if (slashIdx < 0) return null;
        var kind = rest.substring(0, slashIdx);
        var value = rest.substring(slashIdx + 1).trim();
        if (!value) return null;

        if (kind === 'yt' || kind === 'youtube') {
            return { type: 'youtube', url: 'https://youtu.be/' + value, label: 'YouTube' };
        }
        if (kind === 'post') {
            var base = siteRoot(root);
            return { type: 'post', url: (base + '/' + value + '/').replace(/\/+/g, '/').replace(':/', '://'), label: slugToLabel(value) };
        }
        return null;
    }

    function readTagItems(root) {
        var markers = root.querySelectorAll('[data-billyou-tag]');
        var out = [];
        Array.prototype.forEach.call(markers, function (m) {
            var item = itemFromTagName(m.getAttribute('data-billyou-tag'), root);
            if (item) out.push(item);
        });
        return out.slice(0, 3);
    }

    function readJsonOverride() {
        var node = document.querySelector('script[type="application/json"][data-billyou-recs]');
        if (!node || !node.textContent) return null;
        try {
            var data = JSON.parse(node.textContent);
            return Array.isArray(data) ? data : null;
        } catch (e) {
            return null;
        }
    }

    function buildCardEl(item) {
        if (!item || typeof item.url !== 'string') return null;
        var a = document.createElement('a');
        a.className = 'rec-card';
        a.href = item.url;
        a.setAttribute('data-rec-url', item.url);
        var thumb = document.createElement('span');
        thumb.className = 'rec-card-thumb';
        var label = document.createElement('span');
        label.className = 'rec-card-label';
        label.textContent = item.label || item.url;
        a.appendChild(thumb);
        a.appendChild(label);
        return a;
    }

    function clearChildren(node) {
        while (node.firstChild) node.removeChild(node.firstChild);
    }

    function renderItems(list, items) {
        var frag = document.createDocumentFragment();
        var anyValid = false;
        items.forEach(function (item) {
            var el = buildCardEl(item);
            if (el) { frag.appendChild(el); anyValid = true; }
        });
        if (!anyValid) return false;
        clearChildren(list);
        list.appendChild(frag);
        return true;
    }

    function decorateCard(card) {
        var url = card.getAttribute('data-rec-url') || card.getAttribute('href');
        if (!url) return;
        var ytId = youtubeIdFromUrl(url);
        if (!ytId) return;
        card.setAttribute('data-rec-type', 'youtube');
        var thumb = card.querySelector('.rec-card-thumb');
        if (thumb) {
            thumb.style.backgroundImage = 'url("https://img.youtube.com/vi/' + ytId + '/hqdefault.jpg")';
        }
    }

    function init() {
        var root = document.querySelector('[data-billyou-recs-root]');
        if (!root) return;
        var list = root.querySelector('[data-billyou-recs-list]');
        if (!list) return;

        var rendered = false;

        // Priority 1: tags
        var fromTags = readTagItems(root);
        if (fromTags.length) {
            rendered = renderItems(list, fromTags);
        }

        // Priority 2: JSON override (only if tags didn't yield anything)
        if (!rendered) {
            var fromJson = readJsonOverride();
            if (fromJson && fromJson.length) {
                rendered = renderItems(list, fromJson);
            }
        }

        // No tags, no JSON → hide the sidebar entirely.
        if (!rendered) {
            root.style.display = 'none';
            return;
        }

        Array.prototype.forEach.call(root.querySelectorAll('.rec-card'), decorateCard);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
